import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { PageHeader, EmptyState, fmtDate, TYPE_META } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Inbox as InboxIcon, CheckCircle2 } from "@/lib/icons";

export default function Inbox() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  const load = () => api.get("/inbox").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    window.addEventListener("dl-saved", load);
    return () => window.removeEventListener("dl-saved", load);
  }, []);

  const review = async (id, state) => {
    await api.post(`/captures/${id}/review`, { review_state: state });
    toast.success(state === "reviewed" ? "Marked reviewed" : "Archived");
    load();
  };

  if (!data) return <div className="text-slate-500">Loading…</div>;

  return (
    <div className="max-w-4xl mx-auto">
      <PageHeader eyebrow="Collect" color="#F59E0B" title="Collect"
        subtitle="New captures and uploads arrive here. Review the intake, then curate and catalog it." />

      {data.failed_uploads.length > 0 && (
        <div className="dl-card p-4 mb-5 border" style={{ borderColor: "#EF444455" }}>
          <div className="text-sm font-semibold text-red-400 mb-2">Failed uploads</div>
          {data.failed_uploads.map((a) => (
            <div key={a.id} className="text-xs text-slate-400">{a.original_filename} — upload failed. The capture is saved; re-attach from its detail.</div>
          ))}
        </div>
      )}

      {data.unreviewed.length === 0 ? (
        <EmptyState icon={CheckCircle2} title="Dock is clear" hint="Every capture has been reviewed. New captures land here first." />
      ) : (
        <div className="space-y-3">
          {data.unreviewed.map((c) => {
            const meta = TYPE_META[c.type] || TYPE_META.note;
            const Icon = meta.icon;
            return (
              <div key={c.id} data-testid={`inbox-row-${c.id}`} className="dl-card p-4 flex items-center gap-4">
                <span className="h-10 w-10 rounded-lg grid place-items-center shrink-0" style={{ background: meta.color + "22", color: meta.color }}><Icon size={18} /></span>
                <button onClick={() => navigate(`/captures/${c.id}`)} className="flex-1 text-left min-w-0">
                  <div className="text-sm font-semibold text-white truncate">{c.title || "Untitled"}</div>
                  <div className="text-[11px] text-slate-500">{fmtDate(c.created_at)} · {c.type}{c.asset_count ? ` · ${c.asset_count} file(s)` : ""}</div>
                </button>
                <div className="flex gap-2 shrink-0">
                  <Button size="sm" variant="outline" onClick={() => navigate(`/captures/${c.id}`)} data-testid={`inbox-open-${c.id}`}>Open</Button>
                  <Button size="sm" onClick={() => review(c.id, "reviewed")} data-testid={`inbox-review-${c.id}`} style={{ background: "#10B981" }}>Reviewed</Button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
